'use client';

import { useFrame } from '@react-three/fiber';
import type { CloudsEffect } from '@takram/three-clouds';
import { useRef, type FC, type MutableRefObject } from 'react';
import { cloudPointer } from '../cloudPointer';
import { createCloudTrail, trailFade, updateCloudTrail } from '../cloudTrail';
import { skyState } from '../skyStore';

export const CloudInteractionDirector: FC<{
  effectRef: MutableRefObject<CloudsEffect | null>;
}> = ({ effectRef }) => {
  const trail = useRef(createCloudTrail());
  useFrame(({ size }, delta) => {
    const effect = effectRef.current;
    if (!effect) return;
    const settings = skyState.cloudInteraction;
    const now = Date.now();
    updateCloudTrail(trail.current, cloudPointer, settings, now, delta);
    const height = Math.max(1, size.height);
    effect.pointerTrailSoftness = settings.edgeSoftness;
    for (let i = 0; i < effect.pointerTrail.length; i++) {
      const segment = trail.current.segments[i];
      const data = effect.pointerTrailData[i];
      if (!segment) {
        data.set(0, 0, 0, 0);
        continue;
      }
      const { start, end } = segment;
      effect.pointerTrail[i].set(start.x, start.y, end.x, end.y);
      data.set(
        start.radius / height,
        start.strength *
          settings.strength *
          trailFade(start.time, now, settings.trailDuration),
        end.strength *
          settings.strength *
          trailFade(end.time, now, settings.trailDuration),
        end.radius / height
      );
    }
  });
  return null;
};
